<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="ProfissionalBloqueioForm"
      :ordenar-nomes="['Nome', 'Data', 'Motivo']"
      :ordenar-por="['profissional.nome', 'dataInicio', 'motivo']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div
            v-if="usuario.perfil !== 'Profissional'"
            class="form-group col-xs-12 col-sm-8 col-md-6 col-lg-6"
          >
            <BuscarSelecionarProfissional
              @selecionadoProfissional="filtro.profissionalId = $event._id"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataInicio"
              label="Data Início"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataFim"
              label="Data Fim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
          <div class="form-group col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarSituacao @atualizar="filtro.ativo = $event" />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><ProfissionalBloqueioTabela :bloqueios="bloqueios"
      /></template>
      <template #fichas>
        <div
          v-for="bloqueio in bloqueios"
          :key="bloqueio._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <ProfissionalBloqueioFicha :bloqueio="bloqueio" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import MensagemServico from '@/servicos/MensagemServico'
import ProfissionalBloqueioServico from '@/servicos/ProfissionalBloqueioServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import appStore from '@/stores'

import ProfissionalBloqueioFicha from './ProfissionalBloqueioFicha'
import ProfissionalBloqueioTabela from './ProfissionalBloqueioTabela'

const profissionalServico = new ProfissionalServico()
const mensagemServico = new MensagemServico()

export default {
  components: {
    ProfissionalBloqueioFicha,
    ProfissionalBloqueioTabela,
    BlocoFiltroPesquisa,
    BuscarSelecionarProfissional,
    SelecionarData,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = new ProfissionalBloqueioServico()
    const nomeResultado = 'bloqueios'
    const bloqueios = ref([])
    const profissionais = ref([])
    const filtro = ref({
      dataInicio: '',
      dataFim: '',
      ativo: '',
      profissionalId: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: bloqueios,
      servico,
      nomeResultado,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(17)
    return {
      servico,
      bloqueios,
      profissionais,
      filtro,
      ...pesquisa,
    }
  },

  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  created() {
    this.inicializaParaProfissional()
  },
  methods: {
    inicializaParaProfissional() {
      if (this.usuario.perfil === 'Profissional') {
        profissionalServico
          .recuperarTodos({ email: this.usuario.email })
          .then((result) => {
            if (!result.profissionais.length) {
              this.filtro.profissional = this.usuario.nome
              mensagemServico.alerta(
                'O usuário logado não tem cadastro profissional no sistema.'
              )
            } else {
              this.filtro.profissionalId = result.profissionais[0].id
            }

            this.pesquisar()
          })
      }
    },
  },
}
</script>
